/* global $ */

import setEqualHeight from './setEqualHeight'

function onWindowLoad() {
    /*Masonry*/
    $('.masonry').masonry({
        itemSelector: '.masonry-item',
    });

    $('.mid_wrapper').each(function() {
        setEqualHeight($(this).find('.owl-item'));
    });
}

export default onWindowLoad;



// WEBPACK FOOTER //
// ./src/modules/plugins/onWindowLoad.js